import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiHelper } from "../../utils/apiHelper";

// Thunks
export const fetchHeroSliders = createAsyncThunk(
  "hero/fetchHeroSliders",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiHelper.get(`/admin/hero-sliders`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createHeroSlider = createAsyncThunk(
  "hero/createHeroSlider",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiHelper.post(`/admin/hero-slider`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateHeroSlider = createAsyncThunk(
  "hero/updateHeroSlider",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiHelper.put(`/admin/hero-slider`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteHeroSlider = createAsyncThunk(
  "hero/deleteHeroSlider",
  async (sliderId, { rejectWithValue }) => {
    try {
      const response = await ApiHelper.delete(`/admin/hero-slider/${sliderId}`);
      return { sliderId, ...response.data };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  heroSliders: [],
  loading: false,
  error: null
};

const heroSlice = createSlice({
  name: "hero",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Hero Sliders
      .addCase(fetchHeroSliders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHeroSliders.fulfilled, (state, action) => {
        state.loading = false;
        state.heroSliders = action.payload.heroSliders;
      })
      .addCase(fetchHeroSliders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create Hero Slider
      .addCase(createHeroSlider.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createHeroSlider.fulfilled, (state, action) => {
        state.loading = false;
        state.heroSliders = [...state.heroSliders, action.payload];
      })
      .addCase(createHeroSlider.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Hero Slider
      .addCase(updateHeroSlider.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateHeroSlider.fulfilled, (state, action) => {
        state.loading = false;
        state.heroSliders = state.heroSliders.map(slider =>
          slider.sliderId === action.payload.sliderId ? action.payload : slider
        );
      })
      .addCase(updateHeroSlider.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Hero Slider
      .addCase(deleteHeroSlider.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteHeroSlider.fulfilled, (state, action) => {
        state.loading = false;
        state.heroSliders = state.heroSliders.filter(
          (slider) => slider.sliderId !== action.payload.sliderId
        );
      })
      .addCase(deleteHeroSlider.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default heroSlice.reducer;